'use client';

import { useState } from 'react';

import Switcher from 'components/Switcher';
import GithubIllustration from 'layouts/institucional/Section/HowItWorks/GithubIllustration';
import { toOptions } from 'utils/toOptions';
import Section from '..';
import Text from '../Elements/Text';

import styles from './styles.module.css';

type Tab = 'privacy' | 'security';

const tabMap: Record<Tab, string> = {
	security: 'Segurança',
	privacy: 'Privacidade',
};

function SectionHowItWorks() {
	// States
	const [tab, setTab] = useState<Tab>('security');

	return (
		<Section className={styles.container}>
			<Text align="left">
				<Switcher
					options={toOptions(tabMap)}
					optionByValue={tab}
					onChange={(tab) => setTab(tab)}
				/>

				{tab === 'security' && <SectionHowItWorksSecurity />}
				{tab === 'privacy' && <SectionHowItWorksPrivacy />}
			</Text>

			<GithubIllustration />
		</Section>
	);
}

function SectionHowItWorksSecurity() {
	return (
		<>
			<h2>Como funciona a geração de commits</h2>
			<p>
				Utilizamos um modelo da OpenAI, que foi cuidadosamente treinada
				com instruções, configurações e validações específicas para
				gerar mensagens de commit precisas.
				<br />
				<br />
				Importante ressaltar que nenhuma linha do seu código é utilizada
				para treinamento, armazenada em nossos banco de dados ou
				compartilhada com terceiros.
				<br />
				<br />A OpenAI também segue esses termos em seus serviços para
				empresas. Veja mais detalhes{' '}
				<a
					href="https://openai.com/enterprise-privacy/"
					target="_blank"
					rel="noreferrer noopener"
				>
					clicando aqui
				</a>
				.
			</p>
		</>
	);
}

function SectionHowItWorksPrivacy() {
	return (
		<>
			<h2>O que usamos para a geração dos commits</h2>
			<p>
				Nossa CLI identifica as alterações feitas nos arquivos e envia
				apenas as informações necessárias para a geração da mensagem de
				commit. <br />
				<br />
				Por exemplo, se você renomear uma variável de {
					'"products"'
				}{' '}
				para
				{'"pendingProducts"'}, o payload enviado incluirá apenas essas
				mudanças pontuais, como:
			</p>

			<code>
				src/app/dashboard/products/page.ts
				<br />
				<br />
				--- Linha 42: const products = ...;
				<br />
				+++ Linha 42: const pendingProducts = ...;
			</code>
		</>
	);
}

export default SectionHowItWorks;
